// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HeroCarousel.css */

.carousel-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

.carousel-slides {
    display: flex;
    width: 300%;
    /* Adjust according to the number of slides */
    transition: slide-animation 2s ease-in-out;
    
}
.hero-section {
    flex: 1 0 100%;
    background-size: cover;
    background-position: center;
    height: 100%;
    position: relative;
    overflow: hidden;
   
    /* Remove or adjust if necessary for background color handling */
}
.wave-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    /* Adjust height as needed */
 
    z-index: 10;
}

.wave-container svg {
    width: 100%;
    height: auto;
    display: block;
}


    



.hero-section.active {
    display: block;
}

.carousel-control {
    position: absolute;
    width:50px;
    height:50px;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(255,0,0,0.1);
    color: #E42727;
    border: none;
    font-size: 2em;
    cursor: pointer;
    z-index: 2;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.carousel-control p{
    opacity: 0.5;
    font-size: 25px;
    font-weight: 400;
}

.carousel-control:hover{
    background-color: #F2C713;
}

.prev {
    left: 10px;
    
    
}

.next {
    right: 30px;
}

.custom-shape-divider-bottom-1722417268 {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(180deg);
}

.custom-shape-divider-bottom-1722417268 svg {
    position: relative;
    display: block;
    width: calc(139% + 1.3px);
    height: 172px;
}

.custom-shape-divider-bottom-1722417268 .shape-fill {
    fill: #FFFFFF;
}

@media screen and (max-width:768px){
    .carousel-container {
            position: relative;
            width: 100vw;
            height: 90vh;
            overflow: hidden;
            background-color: rgba(255, 0, 0, 0.1);
        }
    .carousel-control {
            position: absolute;
            width: 40px;
            height: 40px;
            top:50%;
            transform: translateY(-50%);
            background-color: none;
            color: #E42727;
            border: none;
            font-size: 2em;
            cursor: pointer;
            z-index: 2;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
                .carousel-control p {
                    opacity: 0.5;
                    font-size: 16px;
                    font-weight: 400;
                }
                .prev {
                    left: 10px;
        
        
                }
        
                .next {
                    right: 0px;
                }
}`, "",{"version":3,"sources":["webpack://./src/Styles/HeroCarousal.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6CAA6C;IAC7C,0CAA0C;;AAE9C;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;;IAEhB,gEAAgE;AACpE;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;;IAE5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;;;;;;AAOA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,mCAAmC;IACnC,cAAc;IACd,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;;;AAGd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;YACQ,kBAAkB;YAClB,YAAY;YACZ,YAAY;YACZ,gBAAgB;YAChB,sCAAsC;QAC1C;IACJ;YACQ,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,OAAO;YACP,2BAA2B;YAC3B,sBAAsB;YACtB,cAAc;YACd,YAAY;YACZ,cAAc;YACd,eAAe;YACf,UAAU;YACV,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,mBAAmB;QACvB;gBACQ;oBACI,YAAY;oBACZ,eAAe;oBACf,gBAAgB;gBACpB;gBACA;oBACI,UAAU;;;gBAGd;;gBAEA;oBACI,UAAU;gBACd;AAChB","sourcesContent":["/* HeroCarousel.css */\n\n.carousel-container {\n    position: relative;\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n}\n\n.carousel-slides {\n    display: flex;\n    width: 300%;\n    /* Adjust according to the number of slides */\n    transition: slide-animation 2s ease-in-out;\n    \n}\n.hero-section {\n    flex: 1 0 100%;\n    background-size: cover;\n    background-position: center;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n   \n    /* Remove or adjust if necessary for background color handling */\n}\n.wave-container {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: auto;\n    /* Adjust height as needed */\n \n    z-index: 10;\n}\n\n.wave-container svg {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\n\n    \n\n\n\n.hero-section.active {\n    display: block;\n}\n\n.carousel-control {\n    position: absolute;\n    width:50px;\n    height:50px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: rgba(255,0,0,0.1);\n    color: #E42727;\n    border: none;\n    font-size: 2em;\n    cursor: pointer;\n    z-index: 2;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.carousel-control p{\n    opacity: 0.5;\n    font-size: 25px;\n    font-weight: 400;\n}\n\n.carousel-control:hover{\n    background-color: #F2C713;\n}\n\n.prev {\n    left: 10px;\n    \n    \n}\n\n.next {\n    right: 30px;\n}\n\n.custom-shape-divider-bottom-1722417268 {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    overflow: hidden;\n    line-height: 0;\n    transform: rotate(180deg);\n}\n\n.custom-shape-divider-bottom-1722417268 svg {\n    position: relative;\n    display: block;\n    width: calc(139% + 1.3px);\n    height: 172px;\n}\n\n.custom-shape-divider-bottom-1722417268 .shape-fill {\n    fill: #FFFFFF;\n}\n\n@media screen and (max-width:768px){\n    .carousel-container {\n            position: relative;\n            width: 100vw;\n            height: 90vh;\n            overflow: hidden;\n            background-color: rgba(255, 0, 0, 0.1);\n        }\n    .carousel-control {\n            position: absolute;\n            width: 40px;\n            height: 40px;\n            top:50%;\n            transform: translateY(-50%);\n            background-color: none;\n            color: #E42727;\n            border: none;\n            font-size: 2em;\n            cursor: pointer;\n            z-index: 2;\n            border-radius: 50%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n                .carousel-control p {\n                    opacity: 0.5;\n                    font-size: 16px;\n                    font-weight: 400;\n                }\n                .prev {\n                    left: 10px;\n        \n        \n                }\n        \n                .next {\n                    right: 0px;\n                }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
